import React from 'react';
import { FiPlus } from 'react-icons/fi';

type NativeInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange'
>;

interface CustomUploadProps extends NativeInputProps {
  onChange: (files: FileList) => void;
  className?: string;
}

const CustomUpload: React.FC<CustomUploadProps> = ({
  onChange,
  className,
  ...inputProps
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    if (!inputProps.disabled) {
      inputRef.current?.click();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      onChange(e.target.files);
    }
  };

  return (
    <div>
      <input
        type="file"
        ref={inputRef}
        onChange={handleChange}
        style={{ display: 'none' }}
        {...inputProps}
      />
      <button
        type="button"
        onClick={handleClick}
        className={`ag-border ag-border-gray-300 ag-rounded-lg ag-flex ag-flex-col ag-items-center ag-justify-center ag-text-gray-600 ag-text-sm ag-font-medium hover:ag-border-gray-500 hover:ag-bg-gray-50 disabled:ag-opacity-50 disabled:ag-cursor-not-allowed ${
          className || ''
        }`}
        disabled={inputProps.disabled}
      >
        <span className="ag-text-sm">
          <FiPlus size="24" />
        </span>
        <span>Upload</span>
      </button>
    </div>
  );
};

export default CustomUpload;
